import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';


// import { FileTransfer } from '@ionic-native/file-transfer/ngx';
// import { FileChooser } from '@ionic-native/file-chooser/ngx';
// import { File } from '@ionic-native/file/ngx';
// import { FilePath } from '@ionic-native/file-path/ngx';
// import { DocumentViewer } from '@ionic-native/document-viewer/ngx';
import { Downloader } from '@ionic-native/downloader/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { Plugins } from '@capacitor/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CommonService } from './services/common.service';
import { DataService } from './services/data.service';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { RouterModule } from '@angular/router';
import { IonicStorageModule } from '@ionic/storage';
import { ReminderPage } from '../app/pages/reminder/reminder.page';
// import { NgxIonicImageViewerModule } from 'ngx-ionic-image-viewer';
import { PhotoViewer } from '@ionic-native/photo-viewer/ngx';
import { ImageViewerPageModule } from './pages/imageviewer/imageviewer.module';
import { AppAvailability } from '@ionic-native/app-availability/ngx';
import { PipesModule } from '../app/pipes/pipes.module';
// import { FileOpener } from '@ionic-native/file-opener/ngx';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { Badge } from '@ionic-native/badge/ngx';
// import { saveAs } from 'file-saver';
const { StatusBar } = Plugins;
@NgModule({
  declarations: [AppComponent, ReminderPage],
  entryComponents: [ReminderPage],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot({
      name: 'npsk'
    }),
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    Ng2GoogleChartsModule,
    ImageViewerPageModule,
    PipesModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    DataService,
    CommonService,
    PhotoViewer,
    // FileTransfer,
    // FileChooser,
    // File,
    // FilePath,
    // DocumentViewer,
    Downloader,
    AppAvailability,
    OneSignal,
    Badge
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
